export enum WhenChoice
{
    When = 'When'
}
